import { Pipe, PipeTransform } from '@angular/core';
import { getSpecialtyDisplayName } from '../common/anaesthesiaIntake';

/** Format specialty labels without changing the values used by selectors or API requests. */
@Pipe({ name: 'specialtyDisplay', standalone: true })
export class SpecialtyDisplayPipe implements PipeTransform {
  transform(value: string | string[] | null | undefined, consultSubType?: string | null): string {
    return Array.isArray(value)
      ? value.map(specialty => getSpecialtyDisplayName(specialty)).join(', ')
      : getSpecialtyDisplayName(value, consultSubType);
  }
}
